// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__UNTPh","secondary":"Button_secondary__6noZl","fullWidth":"Button_fullWidth__Qyy-g"};